(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soiree-hero"] && !Shopify.designMode) return;
  try {
    
  class SoireeHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.soiree-hero__image'));
      this.interval = Number(this.dataset.interval) || 5000;
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      // Cycling is decorative, so it stays off for visitors who ask for less motion
      if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      clearInterval(this.timer);
    }

    next() {
      const upcoming = this.slides[(this.index + 1) % this.slides.length];
      // Skip a turn rather than fade to a photo that has not finished loading
      upcoming.loading = 'eager';
      if (!upcoming.complete) return;

      this.slides[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.slides.length;
      upcoming.classList.add('is-active');
    }
  }

  if (!customElements.get('soiree-hero')) customElements.define('soiree-hero', SoireeHero);

  } catch(e) { console.error(e); }
})();
})();
